import analytics from '~/libs/analytics.client'

analytics.startup()
